module.exports = __webpack_public_path__ + "fonts/fa-brands-400.592643a8.eot";